import { useState, useEffect } from 'react';

/**
 * useConnection - Hook para detectar el estado de la red en tiempo real.
 * Ayuda a la UI a mostrar estados de "Modo Offline" premium.
 */
export const useConnection = () => {
    const [isOnline, setIsOnline] = useState(window.navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return isOnline;
};
